var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-numeric',{class:_vm.className,attrs:{"empty-value":_vm.emptyValue,"min":_vm.min,"max":_vm.max,"minus":_vm.minus,"precision":_vm.precision,"placeholder":_vm.placeholder,"type":"number"},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c42774","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/mdbvue/src/components/NumericInput.vue
// module id = null
// module chunks = 